import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useStyles } from "./indexStyles";
import {
  getLendingRoute,
  isAgentPortalHeaderVisible,
  navigateToUrl,
} from "../../helpers/utils";
import withStyles from "@material-ui/core/styles/withStyles";
import Header from "../header";

function MainLayout({ children, ...rest }) {
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  useEffect(() => {
	if (pathname === "/") {
	  navigateToUrl(getLendingRoute("home"), history);
	}
  }, [pathname, history]);

  return (
	<>
	  {isAgentPortalHeaderVisible(pathname) && <Header />}
	  {children}
	</>
  );
}

export default withStyles(useStyles, { withTheme: true })(MainLayout);
